import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {

  transform(value: any, ...args: any): any {

      if (!args || args[0] === '' || args[0] === undefined || args[0] === null) {
        return value;
      } else {
        const ohneOffeneKlammer = args[0].replace('(', '\\(');
        const escapedKlammern = ohneOffeneKlammer.replace(')', '\\)');
        const re = new RegExp(escapedKlammern, 'gi');
        return value.replace(re, '<strong>$&</strong>');
      }

  }

}
